// extracted by mini-css-extract-plugin
export default {"brdr":"movies_brdr__dTBDO","secondclor":"movies_secondclor__W9nzu"};